<template>
  <div class="news-all">
    <div class="title"><span class="time">02.02<br>2019</span><span class="tiel">淮南牛肉汤，美菜网给你家一样的味道</span></div>
    <div class="mat-content">
        <div class="tet-js">
            每逢过年期间，大部分人已经踏上了归家的旅途，但有人还在坚守岗位。今年除夕那夜，在北京市西城区大栅栏街道石头胡同127号，有一家淮南牛肉汤的小馆子，却还在正常营业。<br/><br/>
            对老板陶平和老板娘朱宗翠来说，依然是平凡又忙碌的一天，两人重复地做着自己这些年一直在做的事情，陶哥揉面、擀面、做烧饼，朱姐熬制牛肉汤、煮牛肉面、做肉夹馍。<br/><br/>
            好像并没有因为昨日铺天盖地的报道，有什么不一样的改变。只是来吃饭的人和目光多了些，有拍照的，有到处看的，有慕名而来的。<br/><br/>
        </div>
        <p align="center"><img src="@/assets/images/new-img/a011_1.jpeg" width="640"></p>
        <div class="tet-js" style="text-align: center">
            淮南牛肉汤店面
        </div>
        <div class="title-bold"><span></span>20年里的朴实无华</div>
        <div class="tet-js">
          今年是陶哥夫妻俩来京的20年，也是他们小店的20年。<br/><br/>
1999年，夫妻二人为养家糊口从安徽马鞍山奔赴北京，在石头胡同附近的一个小档口开始卖烧饼、肉夹馍等，一个热气腾腾的大炉子、一张满是面粉的案台，几乎就是全部。<br/><br/>
店面虽小，但陶哥朱姐的烧饼可是街坊邻居实实在在的心头好，有的老顾客甚至会从广渠门特意赶过来买烧饼。酥脆喷香，价格公道，别家烧饼卖一块五时，他们仍坚持卖五毛。即使物价飞涨的现在，他家烧饼也只卖一块钱。<br/><br/>
两个月之前，由于老城区改造，他们的档口也在其中，夫妻两人便决定趁此机会扩大规模，也就是现如今石头胡同的淮南牛肉汤店。<br/><br/>
初始他们心里也一直犯嘀咕，过往这店铺开的涮羊肉、烤串纷纷倒闭，他们也担心来的老顾客会不会流失，还会吸引到多少新顾客。<br/><br/>
“还好，结果比我们想象的要好得多。”陶哥边揉着面，边笑着说道。<br/><br/>
所幸，结果是好的，现在新店已经步入正轨，不在计划中的搬迁，恰好在20年的时候，他们迎来了新的开始。<br/><br/>

        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
